import WallGreenImg from "../../assets/img/m2-renderizado.png";
import GrowGreenImg from "../../assets/img/growgreen1.jpg";

export const SystemImg = ({ type }) => {
  var img = "";

  if (type === "wallgreen") {
    img = WallGreenImg;
  } else {
    img = GrowGreenImg;
  }

  return (
    <div className="img-system">
      <img key={type} src={img} alt="" />
    </div>
  );
};
